module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/topimg-c4ef8fa4ff6bfb20c45ac1a4ee93cb56.png";